import { shellPlatform } from "./shell-routing";

/**
 * Whether the shell shows its navigation bar over this page.
 *
 * A screen that fills the display and offers one way onward has nothing for a tab bar to
 * do, and on the phone the bar sat over the button that gets you past it. The page is the
 * only thing that knows it is showing such a screen, so the page is what says so.
 *
 * Silent in a browser and in the installed web app: neither has a bar to hide, and the
 * page's own navigation is already hidden inside a shell.
 *
 * A shell too old to carry this bridge keeps its bar, which is what it did before this
 * existed. Wrong in a small way, where refusing to render would be wrong in a large one.
 */
interface ChromeHost {
  webkit?: { messageHandlers?: { VerityConnectChrome?: { postMessage(value: unknown): void } } };
  VerityConnectChrome?: { setNavigationVisible(visible: boolean): void };
}

export function setShellNavigationVisible(
  visible: boolean,
  platform: "ios" | "android" | null = shellPlatform(),
  host: ChromeHost = globalThis as ChromeHost,
): boolean {
  if (!platform) return false;
  const handler = host.webkit?.messageHandlers?.VerityConnectChrome;
  if (handler) { handler.postMessage({ navigation: visible }); return true; }
  if (host.VerityConnectChrome) { host.VerityConnectChrome.setNavigationVisible(visible); return true; }
  return false;
}
